<template>
<div id="cd-cart">
    <div class="cart-header-te" style="padding:0px 0px 0 10px;">
        <h2 class="page-title float-l pt-2 pr-3"> <span class="pr-3">{{cart.length}} Items</span>Total: &#8377; {{getCartTotal}}/-</h2>
        <span class="float-r total-p-p" style="height: 100%;">
            <!-- <button >Go To Cart</button> -->
            <router-link to="/Cart" style="background: transparent;color: #fff;border: none;height: 100%;cursor: pointer;">Cart</router-link>
        </span>
    </div>
</div>
</template>

<script>
export default {
    name: 'Checkout',
    props: ['cart'],
    data() {
        return {
            cartLength:0,
            cartTotal: 0,

        }
    },
    methods:{
    // getCartTotal() {
    //     var t = 0
    //     if (this.cart != null) {
    //         t = this.cart.reduce((acc, item) => acc + (parseInt(item.mrp) * parseInt(item.qty)), 0);
    //     }
    //     return t
    // },
    },
    computed: {
    getCartTotal: function () {
      var t = 0
       if (this.cart != null && this.cart.length>0) {
        //    console.log("mycart "+this.cart)
         //  t = this.cart.reduce((acc, item) => acc + (parseInt(item.mrp) * parseInt(item.qty)), 0);
        var i
        for(i=0;i<this.cart.length;i++)
        {
            var e=this.cart[i]
            t+=(parseInt(e.mrp) * parseInt(e.qty));
        }
    //  this.cart.forEach(e => {t += (parseInt(e.mrp) * parseInt(e.qty));});

         }
        return t
    }
  },
    watch: {
        cart: function () {
            this.cartLength = this.cart.length
            // this.cartTotal = this.getCartTotal()
           // alert("cart : " + this.cart.length + "   " + this.cartLength)
        }
    },
}
</script>
